import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { Tooltip } from "@volt_developers/react-ui-components";
import { useTranslation } from "react-i18next";

import { BLOCKLIST_ICONS } from "../config";

import type { BlockRuleType } from "../models/BlockRules";

export interface BlocklistTypeIconProps extends SvgIconProps {
  type: BlockRuleType;
}

export function BlocklistTypeIcon({ type, ...props }: BlocklistTypeIconProps) {
  const { t } = useTranslation(["circuitBreaker"]);

  return (
    <Tooltip title={t(type).toString()} placement="top">
      <SvgIcon component={BLOCKLIST_ICONS[type]} {...props} />
    </Tooltip>
  );
}
